import { useQuery } from '@tanstack/react-query';
import { BENEFICIARY_KEY } from '../../utils/constants/queryKeys';
import { getBeneficiary } from '../services/fn-api/Beneficiary';

export const useGetBeneficiary = (beneId: number) => {
  return useQuery({
    queryKey: [BENEFICIARY_KEY, beneId],
    queryFn: () => getBeneficiary(beneId),
    enabled: !!beneId,
  });
};
